import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DictionaryService } from 'app/mdm/terminology/dictionary/services/dictionary.service';
import { Dictionary, DictionaryConcept } from 'app/mdm/terminology-lib/services/dictionary';
import { NgForm } from '@angular/forms';

@Component({
  templateUrl: './dictionary-concept-edit.component.html',
})
export class DictionaryConceptEditComponent implements OnInit {
  public isEdit = false;
  public dictionary: Dictionary;
  public concept: DictionaryConcept;
  public versionNumber: number;
  @ViewChild('form') form: NgForm;

  constructor(
    private dictionaryService: DictionaryService,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit(): void {
    const dictionaryId = this.route.snapshot.paramMap.get('dictId');
    this.versionNumber = Number(this.route.snapshot.paramMap.get('vers'));
    const conceptCode = this.route.snapshot.paramMap.get('code');

    this.dictionaryService.getDictionary(dictionaryId).subscribe((r) => {
      this.dictionary = r;
      if (conceptCode) {
        this.isEdit = true;
        this.dictionaryService
          .getVersion(dictionaryId, this.versionNumber, true)
          .subscribe((rr) => (this.concept = rr.concepts.find((e) => e.code === conceptCode)));
      } else {
        this.concept = new DictionaryConcept();
        this.concept.attributes = {};
        if (this.dictionary.attributes) {
          this.dictionary.attributes
            .filter((a) => !!a.defaultValue)
            .forEach((a) => {
              this.concept.attributes[a.id] =
                a.defaultValue instanceof Object ? Object.assign({}, a.defaultValue) : a.defaultValue;
            });
        }
      }
    });
  }

  save(): void {
    delete this.concept.children;
    if (this.isEdit) {
      this.dictionaryService
        .updateConcept(this.dictionary.id, this.versionNumber, this.concept)
        .subscribe((r) => this.goBack());
    } else {
      this.dictionaryService
        .createConcept(this.dictionary.id, this.versionNumber, this.concept)
        .subscribe((r) => this.goBack());
    }
  }

  goBack(): void {
    this.location.back();
  }
}
